import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { changeCustomerShipToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";

import { css } from "styled-components";

changeCustomerShipToSelectorStyles.shipToSelectorDynamicDropdown = mergeToNew(
    changeCustomerShipToSelectorStyles.shipToSelectorDynamicDropdown,
    {
        cssOverrides: {
            list: css`
                max-height: 200px;
                border-left: none;
                border-right: none;
                overflow-y: auto;
            `,
        },
    },
);
